export const MODULE = 'MISCELLANEOUS_FEES';

export const GET_TOTAL_STATS = `${MODULE}/get_total_stats`;
export const GET_GRAPH_STATS = `${MODULE}/get_graph_stats`;

// export const LEGENDS = [
//   { name: 'CLAMP FEE', color: '#5272AA', value: 0 },
//   { name: 'ENVIRONMENTAL FEE', color: '#8EEED7', value: 0 },
// ];

export const LEGENDS = [
  { name: 'WAITING FOR PAYMENT', color: '#5272AA', value: 0 },
  { name: 'PENDING', color: '#8EEED7', value: 0 },
  { name: 'PAID', color: '#7790CB', value: 0 },
  { name: 'EXPIRED REFERENCE NUMBER', color: '#AFF2F3', value: 0 },
];
